"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableSearchbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const InputAdornment_1 = __importDefault(require("@material-ui/core/InputAdornment/InputAdornment"));
const Search_1 = __importDefault(require("@material-ui/icons/Search"));
const Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
const table_context_1 = require("./table-context");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function TableSearchbar() {
    const { disabled, setSearchQuery, searchQuery, classes } = react_1.useContext(table_context_1.TableContext);
    const intl = react_intl_1.useIntl();
    const [searchText, setSearchTextChange] = react_1.useState(searchQuery);
    const handleSearchTextChange = event_callback_hook_1.useEventCallback((e) => {
        const value = e.target.value;
        setSearchTextChange(value);
        setSearchQuery(value.trim());
    });
    const handleClear = event_callback_hook_1.useEventCallback(() => {
        setSearchTextChange('');
        setSearchQuery('');
    });
    return (react_1.default.createElement(TextField_1.default, { disabled: disabled, classes: { root: classes.searchTextField }, autoComplete: "off", id: "outlined-search", type: "search", margin: "dense", placeholder: intl.formatMessage({
            id: 'EAS_TABLE_SEARCHBAR_BTN_SEARCH',
            defaultMessage: 'Vyhledat',
        }), variant: "outlined", value: searchText, onChange: handleSearchTextChange, InputProps: {
            classes: { root: classes.searchTextFieldInput },
            endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end" },
                searchText && (react_1.default.createElement(Clear_1.default, { classes: { root: classes.clearIcon }, onClick: handleClear })),
                react_1.default.createElement(Search_1.default, { classes: { root: classes.searchIcon } }))),
            style: {
                boxShadow: 'none',
                paddingRight: 0,
            },
        } }));
}
exports.TableSearchbar = TableSearchbar;
//# sourceMappingURL=table-searchbar.js.map